export default "__VITE_ASSET__9LoTt0eJ__"